import { all, takeEvery, put, call } from 'redux-saga/effects'
import { notification } from 'antd'
import actions from './actions'
import { SAVE_200_MSG, SAVE_200_DESC, DEL_200_MSG, DEL_200_DESC } from '../../constants'
import { list, find, save, remove } from '../../services/workOrderPhoto'

function* fetchWorkOrderPhotosRefresh() {
  const fe = JSON.parse(localStorage.getItem('fetchWorkOrderPhotos'))
  if (fe == null) {
    fe.size = 100
    fe.index = 0
    fe.searchTerm = '%20'
    fe.orderBy = '%20'
  }
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(list, fe.size, fe.index, fe.searchTerm, fe.orderBy)
  yield put({
    type: actions.LIST_WORKORDERPHOTO,
    result,
  })
}

function* fetchWorkOrderPhotos({ size, index, searchTerm, orderBy }) {
  // Load last params froom last session.
  if (!size && !index && !searchTerm && !orderBy) {
    const fe = JSON.parse(localStorage.getItem('fetchWorkOrderPhotos'))
    if (fe != null) {
      size = 100
      index = fe.index || 0
      searchTerm = fe.searchTerm || '%20'
      orderBy = fe.orderBy || '%20'
    } else {
      size = 100
      index = 0
      searchTerm = '%20'
      orderBy = '%20'
    }
  }
  localStorage.setItem('fetchWorkOrderPhotos', JSON.stringify({ size, index, searchTerm, orderBy }))
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(list, size, index, searchTerm, orderBy)
  yield put({
    type: actions.LIST_WORKORDERPHOTO,
    result,
  })
}

function* fetchWorkOrderPhotoEdit({ id }) {
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(find, id)
  yield put({
    type: actions.EDIT_WORKORDERPHOTO,
    result,
  })
}

function* fetchWorkOrderPhotoSave(values) {
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(save, values)
  if (result !== null) {
    notification.success({ message: SAVE_200_MSG, description: SAVE_200_DESC })
  }
  yield put({
    type: actions.SAVE_WORKORDERPHOTO_RECIEVED,
    result,
  })
  yield put({
    type: actions.RE_FETCH_WORKORDERPHOTOS,
  })
}

function* fetchWorkOrderPhotoDelete(values) {
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(remove, values)
  if (result !== null) {
    notification.success({ message: DEL_200_MSG, description: DEL_200_DESC })
  }
  yield put({
    type: actions.DELETE_WORKORDERPHOTO_RECIEVED,
    result,
  })
  yield put({
    type: actions.RE_FETCH_WORKORDERPHOTOS,
  })
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.FETCH_WORKORDERPHOTOS, fetchWorkOrderPhotos),
    takeEvery(actions.FETCH_WORKORDERPHOTO, fetchWorkOrderPhotoEdit),
    takeEvery(actions.SAVE_WORKORDERPHOTO, fetchWorkOrderPhotoSave),
    takeEvery(actions.DELETE_WORKORDERPHOTO, fetchWorkOrderPhotoDelete),
    takeEvery(actions.RE_FETCH_WORKORDERPHOTOS, fetchWorkOrderPhotosRefresh),
  ])
}
